import React from "react";
import ReportedContent from 'components/admin/ReportedContent';

class ReportedLocations extends React.Component {

    render() {
        return <ReportedContent
            collectionName={'pois'}
        />
    }
}

export default ReportedLocations